import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { ScheduledCampaign, ScheduledCampaignsState } from '../../components/dashboard/scheduledCampaigns/types';

const initialState: ScheduledCampaignsState = {
  campaigns: [],
  loading: false,
  error: null,
};

const scheduledCampaignsSlice = createSlice({
  name: 'scheduledCampaigns',
  initialState,
  reducers: {
    fetchScheduledCampaignsRequest: (state, action: PayloadAction<{ restaurantId: string }>) => {
      state.loading = true;
      state.error = null;
    },
    fetchScheduledCampaignsSuccess: (state, action: PayloadAction<ScheduledCampaign[]>) => {
      state.loading = false;
      // Filter out completed campaigns
      state.campaigns = action.payload.filter(campaign => campaign.status !== 'COMPLETED');
      state.error = null;
    },
    fetchScheduledCampaignsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchScheduledCampaignsRequest,
  fetchScheduledCampaignsSuccess,
  fetchScheduledCampaignsFailure,
} = scheduledCampaignsSlice.actions;

export default scheduledCampaignsSlice.reducer;
